import * as ResourceApi from 'api/resources';
import AccordionSectionWrapper from 'components/common/AccordionSectionWrapper';
import userSearchFormConfig from './UserSearchPanel/userSearchFormConfig';
import {buildHubFilters, buildQueryFilters} from './utils';
import Columns from './columns';

export default {
  '/user*': {
    columns: [
      Columns.Email,
      Columns.Id,
      Columns.Username,
      Columns.FirstName,
      Columns.LastName,
      Columns.SiteId,
      Columns.UserGroup,
      Columns.VerifiedEmail
    ],

    // filter on this resource when searching
    filterResource: ResourceApi.Types.User,

    // function that accepts a query object and builds the appropriate resource filters
    buildFilters: buildQueryFilters,

    // whether to show the Export button in the SearchPanel
    searchFormExport: true,

    // SearchPanel ResourceForm config
    searchFormConfig: userSearchFormConfig,

    // Semantic-legible Grid.Column layout widths
    searchPanelWidth: 4,
    tableWidth: 12,

    // ItemExplorer table props
    tableCollapse: false,

    tableScroll: true,

    topLevelClassName: 'user-management users-list',

    // top-right button configuration
    topButtonConfigs: [
      {
        condition: props => true, // always showing
        buttonClassName: 'create-user-button',
        onClick: 'openCreateUserModal',
        iconClassName: 'create-user-button-icon',
        iconName: 'add user',
        messageKey: 'userManagement.createUser.title'
      }
    ],

    listViewPath: '/users',  // route for ListUsersPage
    detailViewPath: '/user', // route for user detail view

    pageHeaderKey: 'userManagement.title',                 // page-level title
    listHeaderKey: 'userManagement.usersList.header',      // list view title
    searchHeaderKey: 'userManagement.searchPanel.header',  // SearchPanel title
    searchButtonKey: 'userManagement.searchPanel.submit',  // SearchPanel submit button

    allowClearQuery: false,
    clearButtonKey: 'userManagement.searchPanel.clear'     // SearchPanel "clear" button
  },

  
};



// WEBPACK FOOTER //
// ./public/pages/UserManagement/configs.js